module.exports = __webpack_public_path__ + "img/logo.7fe38e11.png";